module.exports = __webpack_public_path__ + "img/Ellipse10.3e76751a.png";